'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp2;

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxAsyncConnect = require('redux-async-connect');

var _reactRedux = require('react-redux');

var _reactRouterBootstrap = require('react-router-bootstrap');

var _reactBootstrap = require('react-bootstrap');

var _app = require('redux/modules/app');

var _reactIntl = require('react-intl');

var _helpers = require('./../../helpers');

var _ = require('./../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./PageApp.scss');

var NewLogo = require('./NewLogo.png');
var EnLogo = require('./EnLogo.png');

var App = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var state = getState();
    var appId = state.routing.locationBeforeTransitions.pathname.match(/\/apps\/(.+)/)[1];
    return dispatch((0, _app.getApp)(appId));
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return (0, _helpers.mapConnect)(state, {
    app: 'app.app'
  });
}), _dec(_class = _dec2(_class = (0, _reactIntl.injectIntl)(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = App.__proto__ || (0, _getPrototypeOf2.default)(App)).call.apply(_ref2, [this].concat(args))), _this), _this.handleFeedbackButtonClick = function () {
      _this.refs.containerModalFeedback.getWrappedInstance().showModal();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(App, [{
    key: 'renderBreadcrumb',
    value: function renderBreadcrumb(app) {
      return _react2.default.createElement(
        'ul',
        { className: 'breadcrumb' },
        _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(
            _reactRouterBootstrap.LinkContainer,
            { to: '/' },
            _react2.default.createElement(
              'a',
              null,
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'digital-toolbox-app-list' })
            )
          )
        ),
        _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: app.introTitleId })
        )
      );
    }
  }, {
    key: 'renderDownloadItems',
    value: function renderDownloadItems(app) {
      return app.releasedApps.map(function (row, index) {
        return _react2.default.createElement(
          _reactBootstrap.MenuItem,
          { key: 'download-link-' + index, href: row.href, target: row.target },
          row.platform,
          ' ( ',
          row.version,
          ' )'
        );
      });
    }
  }, {
    key: 'renderLogoBox',
    value: function renderLogoBox(app) {
      return _react2.default.createElement(
        'div',
        { className: styles.logoBox },
        _react2.default.createElement(
          'div',
          { className: styles.logoBoxHead },
          _react2.default.createElement('img', { src: '/single/' + app.imageSinglePage, alt: app.imageSingleAlt })
        )
      );
    }
  }, {
    key: 'renderContentBox',
    value: function renderContentBox(app) {
      return _react2.default.createElement(
        'div',
        { className: styles.contentBox },
        _react2.default.createElement(
          'div',
          { className: styles.contentBoxIntro },
          _react2.default.createElement(
            'h2',
            { className: 'shuriken' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: app.introTitleId })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.textIntroContent },
            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: app.introContentId })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.contentBoxVersionInfo },
          _react2.default.createElement(
            'h2',
            { className: 'shuriken' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: app.versionTitleId, values: { version: app.titleVersion } })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.textVersionContent },
            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: app.versionContentId })
          )
        )
      );
    }
  }, {
    key: 'renderProductInfoFields',
    value: function renderProductInfoFields(fields) {
      var formatMessage = this.props.intl.formatMessage;


      return fields.map(function (row, index) {

        if (row.languageIds) {
          return _react2.default.createElement(
            'li',
            { key: 'product-info-field-' + index },
            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'language' }),
            _react2.default.createElement(
              'span',
              null,
              ': '
            ),
            row.languageIds.map(function (id) {
              return formatMessage({ id: id });
            }).join(', ')
          );
        }

        if (row.developerId) {
          return _react2.default.createElement(
            'li',
            { key: 'product-info-field-' + index },
            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'developer' }),
            _react2.default.createElement(
              'span',
              null,
              ': '
            ),
            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: row.developerId })
          );
        }

        if (row.copyrightId) {
          return _react2.default.createElement(
            'li',
            { key: 'product-info-field-' + index },
            _react2.default.createElement(
              'span',
              null,
              '\u24B8'
            ),
            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: row.copyrightId })
          );
        }
      });
    }
  }, {
    key: 'renderProductInfoVersionRows',
    value: function renderProductInfoVersionRows(app) {
      var releasedApps = app.releasedApps,
          inProgressApp = app.inProgressApp;


      var html = (releasedApps || []).map(function (row, index) {
        return _react2.default.createElement(
          'li',
          { key: 'product-info-released-app-' + index },
          _react2.default.createElement(
            'div',
            { className: 'clearfix' },
            _react2.default.createElement(
              'a',
              { className: styles.btnPlatform, href: row.href, target: row.target || '_self' },
              row.platform
            ),
            _react2.default.createElement(
              'div',
              { className: styles.versionTextBox },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'released' })
              ),
              _react2.default.createElement(
                'div',
                { className: styles.versionLabel },
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newest-version' }),
                _react2.default.createElement(
                  'span',
                  null,
                  ': '
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  row.version
                )
              )
            )
          )
        );
      });

      html = html.concat((inProgressApp || []).map(function (row, index) {
        return _react2.default.createElement(
          'li',
          { key: 'product-info-inprogress-app-' + index },
          _react2.default.createElement(
            'div',
            { className: 'clearfix' },
            _react2.default.createElement(
              _reactBootstrap.Button,
              { bsSize: 'large', disabled: true },
              row.platform
            ),
            _react2.default.createElement(
              'div',
              { className: styles.releaseTextBox },
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'plan-release-date' }),
              _react2.default.createElement(
                'span',
                null,
                ': '
              ),
              _react2.default.createElement(
                'span',
                null,
                row.planReleaseDate
              )
            )
          )
        );
      }));

      return html;
    }
  }, {
    key: 'renderProductInfoBox',
    value: function renderProductInfoBox(app) {
      return _react2.default.createElement(
        'div',
        { className: '' + styles.infoBox },
        _react2.default.createElement(
          'h2',
          { className: 'shuriken' },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'page-app-product-info' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: styles.productFields + ' col-sm-6' },
            _react2.default.createElement(
              'ul',
              null,
              this.renderProductInfoFields(app.productInfo)
            ),
            _react2.default.createElement('img', { src: NewLogo, alt: 'logo image' }),
            _react2.default.createElement('img', { src: EnLogo, alt: 'logo image' })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.versionRows + ' col-sm-6' },
            _react2.default.createElement(
              'ul',
              null,
              this.renderProductInfoVersionRows(app)
            )
          )
        )
      );
    }
  }, {
    key: 'renderLicenseBox',
    value: function renderLicenseBox(app) {
      return _react2.default.createElement(
        'div',
        { className: styles.infoBox },
        _react2.default.createElement(
          'h2',
          { className: 'shuriken' },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'page-app-copyright' })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.textLicenseBox },
          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: app.copyrightContentId })
        )
      );
    }
  }, {
    key: 'renderDownloadUsageLinks',
    value: function renderDownloadUsageLinks(links) {
      return (links || []).map(function (row, index) {
        return _react2.default.createElement(
          'li',
          { key: 'download-usage-' + index },
          _react2.default.createElement(
            'a',
            { href: row.href, target: row.target || '_self' },
            row.text
          )
        );
      });
    }
  }, {
    key: 'renderDownloadInfoBox',
    value: function renderDownloadInfoBox(app) {

      return _react2.default.createElement(
        'div',
        { className: styles.infoBox },
        _react2.default.createElement(
          'h2',
          { className: 'shuriken' },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'page-app-download-usage' })
        ),
        _react2.default.createElement(
          'ul',
          null,
          this.renderDownloadUsageLinks(app.manualLinks)
        )
      );
    }
  }, {
    key: 'renderFeedbackForm',
    value: function renderFeedbackForm() {
      return _react2.default.createElement(
        'div',
        { className: styles.infoBox + ' ' + styles.feedback },
        _react2.default.createElement(
          'h2',
          { className: 'shuriken' },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'page-app-user-feedback' })
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'page-app-feedback-content' })
        ),
        _react2.default.createElement(
          _reactBootstrap.Button,
          { bsStyle: 'primary', bsSize: 'large', onClick: this.handleFeedbackButtonClick },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'page-app-write-feedback' })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var app = this.props.app;


      return _react2.default.createElement(
        'div',
        { className: styles.pageApp },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Page App' }),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          this.renderBreadcrumb(app),
          _react2.default.createElement(
            'div',
            { className: styles.jumbotron + ' clearfix' },
            this.renderLogoBox(app),
            this.renderContentBox(app)
          ),
          this.renderProductInfoBox(app),
          this.renderLicenseBox(app),
          (app.manualLinks || []).length > 0 && this.renderDownloadInfoBox(app),
          this.renderFeedbackForm(app)
        ),
        _react2.default.createElement(_.ContainerModalFeedback, { ref: 'containerModalFeedback' })
      );
    }
  }]);
  return App;
}(_react.Component), _class2.propTypes = {
  intl: _react.PropTypes.object.isRequired,
  app: _react.PropTypes.object.isRequired
}, _temp2)) || _class) || _class) || _class);
exports.default = App;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/PageApp/PageApp.js
 ** module id = 1237
 ** module chunks = 0
 **/